import React from 'react';
import { ScaleIcon, BriefcaseIcon, HomeIcon, UsersIcon, SearchIcon, HardHatIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
export const Services = () => {
  const services = [{
    id: 1,
    title: 'Electronic Surveillance',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/qgNtGkpRG3JxGLJJg4i5KX/Electronic-Survielence.png'
  }, {
    id: 2,
    title: 'Missing Persons',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aXhBkZcrrxVBGDUunWGe7s/Missing-Persons.png'
  }, {
    id: 3,
    title: 'Workers Compensation & Insurance Fraud',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2RftDubX4ncxqRs2EP934N/Workers-Compensation-and-Insurance-Fraud.png'
  }, {
    id: 4,
    title: 'Domestic Cases',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/fR7GQrhAxCEbosBfJ6QbgQ/Domestic-Cases.png'
  }, {
    id: 5,
    title: 'Child Welfare and Custody',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5RtgPVJEvcRmyLqmmpELb5/Child-Welfare-and-Custody.png'
  }, {
    id: 6,
    title: 'Trial Preparation',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/vNV2JbCwPDpvgaEu6z7QQk/Trial-Preparation.png'
  }, {
    id: 7,
    title: 'Background Investigations',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hHEygesXCWoz9KettmJqZP/Background-Investigations.png'
  }, {
    id: 8,
    title: 'Process Serving',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uC9wBPs63MjnohrbZGAjXv/Process-Serving.png'
  }, {
    id: 9,
    title: 'Security',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/ebcWRKXb2cpJNKnk8YnZKZ/Security.png'
  }, {
    id: 10,
    title: 'Global Positioning Devices',
    bgImage: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gLMp499ksh7AbAHn2Uqvdc/Global-Positioning-Devices.png'
  }];
  const investigationTypes = [{
    name: 'Criminal',
    icon: ScaleIcon,
    path: '/criminal-investigations'
  }, {
    name: 'Corporate',
    icon: BriefcaseIcon,
    path: '/corporate-investigations'
  }, {
    name: 'Domestic',
    icon: HomeIcon,
    path: '/domestic-investigations'
  }, {
    name: 'Child Custody',
    icon: UsersIcon,
    path: '/child-custody-investigations'
  }, {
    name: 'Missing Persons',
    icon: SearchIcon,
    path: '/missing-persons-investigations'
  }, {
    name: 'Construction Investigations',
    icon: HardHatIcon,
    path: '/construction-investigations'
  }];
  return <section id="services" className="py-16 bg-gradient-to-br from-kgi-blue-900 via-kgi-blue-800 to-kgi-blue-900" data-id="element-291">
      <div className="container mx-auto px-4" data-id="element-292">
        {/* Hero heading */}
        <div className="max-w-4xl mx-auto text-center mb-10" data-id="element-293">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-white mb-4 leading-tight" data-id="element-294">
            What We Investigate
          </h2>
          <p className="text-lg text-blue-100 mb-3" data-id="element-295">
            We handle the following legal investigations:
          </p>
          <p className="text-base text-blue-200 mb-6 max-w-3xl mx-auto leading-relaxed" data-id="element-296">
            From criminal defense to corporate investigations, our licensed team
            delivers comprehensive investigative services backed by cutting-edge
            technology and decades of field experience. Every case receives the
            meticulous attention and professional discretion it deserves.
          </p>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3 max-w-2xl mx-auto mb-6" data-id="element-297">
            {investigationTypes.map((type, index) => {
            const Icon = type.icon;
            return <Link key={index} to={type.path} className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-3 hover:bg-white/20 transition-all duration-300" data-id="element-298">
                  <Icon className="h-6 w-6 text-white mx-auto mb-2" data-id="element-299" />
                  <p className="text-white font-semibold text-sm md:text-base" data-id="element-300">
                    {type.name}
                  </p>
                </Link>;
          })}
          </div>
        </div>
        {/* Services grid */}
        <div className="max-w-6xl mx-auto mb-8" data-id="element-301">
          <p className="text-center text-blue-100 mb-6 text-base" data-id="element-302">
            Leveraging state-of-the-art surveillance equipment, GPS tracking
            systems, and proven investigative methodologies, we uncover the
            truth with precision and professionalism.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3 mb-8" data-id="element-303">
            {services.map(service => <div key={service.id} className="relative overflow-hidden rounded-xl group cursor-pointer transform transition-all duration-300 hover:-translate-y-1 hover:shadow-2xl aspect-video" data-id="element-304">
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-transparent z-10" data-id="element-305"></div>
                <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
              backgroundImage: `url(${service.bgImage})`
            }} data-id="element-306"></div>
                <div className="relative z-20 h-full flex items-end p-4" data-id="element-307">
                  <h3 className="font-serif text-base md:text-lg font-bold text-white leading-tight" data-id="element-308">
                    {service.title}
                  </h3>
                </div>
              </div>)}
          </div>
        </div>
        <div className="text-center space-y-4" data-id="element-309">
          <a href="#contact" className="inline-flex items-center bg-white hover:bg-gray-100 text-kgi-blue-900 font-bold py-3 px-8 rounded-full transition duration-300 shadow-xl text-base mr-4" data-id="element-310">
            Discuss Your Case
          </a>
          <a href="#about" className="inline-flex items-center bg-kgi-blue-700 hover:bg-kgi-blue-600 text-white font-bold py-3 px-8 rounded-full transition duration-300 shadow-xl text-base border-2 border-white/30" data-id="element-311">
            Meet Our Team
          </a>
        </div>
      </div>
    </section>;
};